import {
  createUpdateInfiniteDataRecipe,
  createUpdateSingleItemRecipe,
} from '@autone/utils';

import { type TransformedAssortmentProductLocationsResponse } from '../schemas/get-assortment-product-locations.schema';
import { type EditAssortmentProductLocationRequest } from '../types';

type RowIdentifier = { locationId: string };

type EditProductLocationRequestBody =
  EditAssortmentProductLocationRequest['body'];

export const createUpdateProductLocationSkuCountsRecipe = (
  { locationId }: RowIdentifier,
  {
    assortment_update: { update_type, new_value },
  }: EditProductLocationRequestBody,
) =>
  createUpdateInfiniteDataRecipe(
    createUpdateSingleItemRecipe<TransformedAssortmentProductLocationsResponse>(
      {
        predicate: (item) => item.location.id === locationId,
        updateRecipe: (item) => {
          if (update_type === 'is_assorted') {
            item.sku_counts.assorted = new_value ? item.sku_counts.total : 0;
          }
        },
      },
    ),
  );
